import * as THREE from 'three';
import { fragment, vertex } from './bubbleShader';
import Texture from '../Texture';

const PROPS = {
  noise: 0,
  hoverRadius: 0,
  roughness: 0,
  displayMessage: 'HELLO',
  messageStart: 100,
  messageEnd: 1000,
  onClick: () => {},
};
class Bubble extends THREE.Mesh {
  intersected = false;

  constructor(props) {
    super(new THREE.SphereGeometry(2, 64, 64));

    this.textureCanvas = new Texture({
      message: props.displayMessage,
      firstLinePos: props.messageStart,
      lastLinePos: props.messageEnd,
    });

    this.props = { ...PROPS, ...props };
    this.texture = this.textureCanvas.canvas;

    this.createMaterial();

    this.show = this.textureCanvas.show;
    this.hide = this.textureCanvas.hide;

    window.addEventListener('click', () => {
      if (this.intersected) {
        this.props.onClick();
      }
    });
  }

  createMaterial() {
    this.material = new THREE.MeshStandardMaterial({
      roughness: this.props.roughness,
      color: 0x000000,
      transparent: true,
      side: THREE.DoubleSide,
      onBeforeCompile: (shader) => {
        shader.uniforms.uNoise = { value: this.props.noise };
        shader.uniforms.uHoverRadius = { value: this.props.hoverRadius };

        shader.uniforms.uTime = { value: 0 };
        shader.uniforms.uIntersectPoint = { value: new THREE.Vector3(-10) };
        shader.uniforms.uTexture = { value: new THREE.CanvasTexture(this.texture), type: 't' };

        shader.fragmentShader = fragment;
        shader.vertexShader = vertex;

        this.material.userData.shader = shader;
      },
    });

    this.castShadow = true;
    this.receiveShadow = true;
  }

  cancelIntersection() {
    if (!this.material?.userData?.shader?.uniforms || !this.intersected) return;
    this.intersected = false;
    this.material.userData.shader.uniforms.uIntersectPoint.value = new THREE.Vector3(-10);
  }

  intersectPoint(p) {
    if (!this.material?.userData?.shader?.uniforms) return;
    this.intersected = true;
    this.material.userData.shader.uniforms.uIntersectPoint.value = p;
  }

  setNoise(noise) {
    if (!this.material?.userData?.shader?.uniforms) return;
    this.material.userData.shader.uniforms.uNoise = { value: noise };
  }

  tick(time, animate) {
    if (!this.material?.userData?.shader?.uniforms) return;
    if (animate) this.material.userData.shader.uniforms.uTime.value = time;
    this.material.userData.shader.uniforms.uTexture.value = new THREE.CanvasTexture(this.texture);
    this.material.userData.shader.uniforms.uTexture.value.needsUpdate = true;
  }
}

export default Bubble;
